export const registeredAccountsMutation = (builder) => ({
  getRegisteredAccounts: builder.mutation({
    query: ({ pageNumber, limit, search, enterprise_id, sortBy, sortOrder }) => {
      const token = JSON.parse(localStorage.getItem('TOKEN'))?.token || '';

      return {
        url: '/get_registered_accounts',
        method: 'GET',
        params: {
          pageNumber,
          limit,
          search, 
          enterprise_id,
          sortBy, 
          sortOrder
        },
        headers: {
          'Content-Type': 'application/json',
          'Authorization': token
        },
      };
    },
  }),
});

